import { Component, OnInit, Input, OnChanges, ViewChild, SimpleChanges } from '@angular/core';
import { DeduccionesIIGG } from '../../../../models/deducciones-IIGG';
import { DeducionesIiggDetalleComponent } from '../deduciones-iigg-detalle/deduciones-iigg-detalle.component';
import { ErroresService } from '../../../../core/services/errores.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { DeduccionesIiggService } from '../../../../services/deducciones-iigg.service';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { IboxtoolsItem } from '../../../../models/iboxtools-item';
import { GruposLiquidacionService } from '../../../../services/gruposLiquidacion.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-deduciones-iigg',
  templateUrl: './deduciones-iigg.component.html',
  styleUrls: ['./deduciones-iigg.component.css']
})
export class DeducionesIiggComponent implements OnInit, OnChanges {

  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;
  disabledEditing: boolean;
  deduccion: DeduccionesIIGG;
  verDetalle: boolean = false;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  habilitarFormDetalle: boolean = false;
  MensajeError: string;

  //Control ibox
  deduccionesHistoryList: any;
  deduccionesList: DeduccionesIIGG[];
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;
  deducciones: DeduccionesIIGG[];
  buscando: boolean;
  cortarRegistro: boolean = false;

  ingreso: any;
  desdeAnterior: boolean = false;
  anteriorRetroactividad: boolean = false;
  deduccionesInvalida: boolean = false;

  public cargaCompleta: boolean = false;

  @ViewChild('ChildDeduccionesIIGGDetalle') deduccionesIIGGDetalle: DeducionesIiggDetalleComponent;

  constructor(private deduccionesService: DeduccionesIiggService, 
              private dialog: MatDialog, 
              private erroresService: ErroresService, 
              private snackBar: MatSnackBar, 
              private gruposLiquidacionService: GruposLiquidacionService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.obtenerDeducciones(false);

    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Deducciones IIGG")) this.permisoEdicion = true;
  }

  obtenerDeducciones(agrupar)
  {
    this.buscando = true;
    this.deduccionesService.getByPersonal(this.personalId, agrupar).subscribe(
      data =>
      {
        data.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.deducciones = data;
        this.buscando = false;
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        this.buscando = false;
        console.log(error);
      });
  }

  ngOnChanges(changes: SimpleChanges): void
  {
    //throw new Error("Method not implemented.");
  }

  async OnVisualizarDetalle(deduccion)
  {
    if (deduccion.id != 0)
    {
      this.obtenerHistorial(deduccion);
    }
    else
    {
      if (await this.verEstadoNomina())
      {
        this.verDetalle = true;
        this.deduccion = deduccion;
        this.habilitarEdicion();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.deduccion))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.deduccionesService.delete(this.deduccion.id).subscribe(
            response =>
            {
              this.snackBar.open("Eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              let deduccion = this.deduccionesList.filter(d => d.id != this.deduccion.id)[0];
              if (deduccion == undefined)
              {
                this.volverAtras();
              }

              this.obtenerHistorial(deduccion);
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.deduccion))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.deduccionesIIGGDetalle.form.controls['desde'].disable();
        $this.deduccionesIIGGDetalle.form.controls['hasta'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let dedu = this.deduccionesList.find(d => d.id == index);
    this.deduccion = dedu;
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    this.deduccionesIIGGDetalle.setearForm(this.deduccion);
    this.deshabilitarEdicion();
  }

  OnSaveChange(e: boolean)
  {
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.deduccionesIIGGDetalle.form.getRawValue();

      let datosDed: DeduccionesIIGG = {
        id: formulario.id,
        personal: formulario.personal,
        desde: this.momentService.saveDateServer(formulario.desde, false),
        hasta: this.momentService.saveDateServer(formulario.hasta, false),
        personaJuridica: formulario.personaJuridica,
        claseDocumento: formulario.claseDocumento,
        docNro: formulario.docNro,
        cantidad: formulario.cantidad,
        importe: formulario.importe,
        moneda: formulario.moneda,
        codigoNomina: formulario.codigoNomina
      };

      this.deduccionesService.save(datosDed, this.cortarRegistro).subscribe(
        deduccion =>
        {
          deduccion.desde = this.momentService.convertDateServer(deduccion.desde);
          deduccion.hasta = this.momentService.convertDateServer(deduccion.hasta);

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Deducción guardada", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial(deduccion);
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          //deduccion.desde = deduccion.desde.replace('Z', '');
          this.deduccionesIIGGDetalle.setearForm(deduccion);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.habilitarEdicion();
      this.deduccionesIIGGDetalle.form.controls['id'].setValue(0);
      this.deduccionesIIGGDetalle.form.controls['hasta'].setValue(new Date("2999-12-31T23:59:59"));
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      setTimeout(function ()
      {
        $this.deduccionesIIGGDetalle.form.controls['hasta'].disable();
      });
    }
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarFormDetalle = false;
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarFormDetalle = true;
  }

  private volverAtras()
  {
    this.MensajeError = "";
    this.deduccionesHistoryList = [];
    this.deduccionesList = [];
    this.habilitarFormDetalle = false;
    this.verDetalle = false;
    this.obtenerDeducciones(false);
  }

  private obtenerHistorial(deduccion: DeduccionesIIGG)
  {
    this.deduccionesService.getHistoryByClase(deduccion.personal, deduccion.codigoNomina).subscribe(
      deducciones =>
      {
        deducciones.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.deduccionesHistoryList = [];
        deducciones.forEach(d =>
        {
          let item = new IboxtoolsItem(d);
          this.deduccionesHistoryList.push(item);
        });

        this.deduccionesList = deducciones;
        this.verDetalle = true;
        this.deduccion = deduccion;
      },
      error =>
      {
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";

    //TODO. Revisar
    if (this.deduccionesIIGGDetalle.form.get("moneda").value == 0)
    {
      this.deduccionesIIGGDetalle.form.get("moneda").setErrors({ 'invalid': true });
    }

    if (this.deduccionesIIGGDetalle.form.get("claseDocumento").value == 0)
    {
      this.deduccionesIIGGDetalle.form.get("claseDocumento").setErrors({ 'invalid': true });
    }    

    if (this.deduccionesIIGGDetalle.form.get("codigoNomina").value == 0)
    {
      this.deduccionesIIGGDetalle.form.get("codigoNomina").setErrors({ 'invalid': true });
    }

    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.deduccionesIIGGDetalle.form.get("desde").value.toDateString();
    let hasta = this.deduccionesIIGGDetalle.form.get("hasta").value.toDateString();
    let hoy = new Date()

    let fingreso = new Date(this.ingreso.desde).toDateString();
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      this.desdeAnterior = true;
      this.deduccionesIIGGDetalle.form.get("desde").setErrors({'desdeAnterior': true });
    } else {
      //valida que la fecha desde no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(desde) < Date.parse(fretro) )
        {
          this.anteriorRetroactividad = true;
          this.deduccionesIIGGDetalle.form.get("desde").setErrors({'anteriorRetroactividad': true });
        }
      }
    }

    if (this.deduccionesIIGGDetalle.form.valid)
    {
      return true;
    }
    else
    {
      this.deduccionesIIGGDetalle.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(desde) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.desde);
      if(anterior) edita = false;  
    }
    return edita;
  }
  
}
